import React, {useState} from 'react';
import FadeSlideIn from "../../common/FadeSlideIn";
import leaderboardHeader from "../../../resources/leaderboardHeader.png";
import logoRoll from "../../../resources/logoRoll.png";
import logoLuxdrop from "../../../resources/luxdropLogo.png";
import logoHypedrop from "../../../resources/logoHypedrop.png";
import logoStake from "../../../resources/logoStake.png";
import logoCsbattle from "../../../resources/csbattle_logo.svg";
import RollLeaderboard from "../leaderboard/RollLeaderboard";
import LuxdropLeaderboard from "../leaderboard/LuxdropLeaderboard";
import StakeLeaderboard from "../leaderboard/StakeLeaderboard";
import HypedropLeaderboard from "../leaderboard/HypedropLeaderboard";
import CsbattleLeaderboard from "../leaderboard/CsbattleLeaderboard";

const LandingLeaderboards = () => {

    const [shownLeaderboard, setShownLeaderboard] = useState(1);

    return (<FadeSlideIn>
        <div className="landingLeaderboards">
            <div className={`leaderboardBackdrop min`}>
                <div className={`container`}>

                    <div className="leaderboardHeader">

                        <img src={leaderboardHeader} alt=""/>

                        <div className="leaderboardSwitcher">
                            <button type="button" className={`leaderboardStake ${shownLeaderboard === 1 ? 'active' : ''}`}
                               onClick={() => setShownLeaderboard(1)}>
                                <img src={logoStake} alt="" style={{height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain'}}/>
                            </button>
                            <button type="button" className={`leaderboardLuxdrop ${shownLeaderboard === 4 ? 'active' : ''}`}
                               onClick={() => setShownLeaderboard(4)}>
                                <img src={logoLuxdrop} alt="" style={{height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain'}}/>
                            </button>
                            <button type="button" className={`leaderboardRoll ${shownLeaderboard === 3 ? 'active' : ''}`}
                               onClick={() => setShownLeaderboard(3)}>
                                <img src={logoRoll} alt="" style={{height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain'}}/>
                            </button>
                            <button type="button" className={`leaderboardHypedrop ${shownLeaderboard === 5 ? 'active' : ''}`}
                               onClick={() => setShownLeaderboard(5)}>
                                <img src={logoHypedrop} alt="" style={{height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain'}}/>
                            </button>
                            {/*<button type="button" className={`leaderboardCsbattle ${shownLeaderboard === 6 ? 'active' : ''}`}
                               onClick={() => setShownLeaderboard(6)}>
                                <img src={logoCsbattle} alt="" style={{height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain'}}/>
                            </button>*/}
                        </div>

                    </div>

                    <div>
                        {shownLeaderboard === 1 && <StakeLeaderboard showMinimalDetails={true}/>}
                        {shownLeaderboard === 3 && <RollLeaderboard showMinimalDetails={true}/>}
                        {shownLeaderboard === 4 && <LuxdropLeaderboard showMinimalDetails={true}/>}
                        {shownLeaderboard === 5 && <HypedropLeaderboard showMinimalDetails={true}/>}
                        {/*{shownLeaderboard === 6 && <CsbattleLeaderboard showMinimalDetails={true}/>}*/}
                    </div>


                </div>

            </div>
        </div>
    </FadeSlideIn>);
}
export default LandingLeaderboards;
